import React, { useState } from "react";
import Input from "../Input";
import Button from "../Button";
import DateInput from "../dateInput";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import { AddSaleTransaction } from "../../redux/Transaction/action";
import { useNavigate } from "react-router-dom";
import { validateForm } from "../../validation/TransactionValidation";
import Loader from "../loader";

const TransactionSaleForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [data, setData] = useState({
    date: dayjs().format("DD/MM/YYYY"), // Set default date to today's date
    nonvatsale: Number,
    vatsale: Number,
    vatamount: Number,
    cashamount: Number,
    bankamount: Number,
    lottery: Number,
    payzone: Number,
    oyester: Number,
    status: Number,
  });
  const [errors, setErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (isSubmit) {
      // Validate on change
      const updatedErrors = validateForm({
        ...data,
        [name]: value,
      });
      setErrors(updatedErrors);
    }
  };

  const handleDateChange = (date, dateString) => {
    setData((prevData) => ({
      ...prevData,
      date: dateString,
    }));

    if (isSubmit) {
      // Validate on change
      const updatedErrors = validateForm({
        ...data,
        date: dateString,
      });
      setErrors(updatedErrors);
    }
  };

  const resetForm = () => {
    setData({
      date: dayjs().format("DD/MM/YYYY"), // Set default date to today's date
      nonvatsale: Number,
      vatsale: Number,
      vatamount: Number,
      cashamount: Number,
      bankamount: Number,
      lottery: Number,
      payzone: Number,
      oyester: Number,
      status: Number,
    });
    setErrors({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmit(true);
    const validationErrors = validateForm(data);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      try {
        setLoading(true);
        let obj = {
          date: data?.date,
          nonvatsale: Number(data?.nonvatsale),
          vatsale: Number(data?.vatsale),
          vatamount: Number(data?.vatamount),
          cashamount: Number(data?.cashamount),
          bankamount: Number(data?.bankamount),
          lottery: Number(data?.lottery),
          payzone: Number(data?.payzone),
          oyester: Number(data?.oyester),
          status: false,
        };
        await dispatch(AddSaleTransaction(obj)).then((res) => {
          if (res?.status === 200) {
            resetForm();
            setLoading(false);
            navigate("/home/dashboard/sale");
          } else if (res?.status === 401) {
            setLoading(false);
            navigate("/");
          }
        });
        setLoading(false);
      } catch (error) {
        console.log("error", error);
        setLoading(false);
        return error;
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="text-base font-normal">
        <div className="grid grid-cols-3 max-lg:grid-cols-2 max-sm:grid-cols-1 gap-x-6 gap-y-7 max-sm:gap-y-4">
          <div>
            <DateInput
              onChange={handleDateChange}
              value={data.date ? dayjs(data.date, "DD/MM/YYYY") : null}
              name={"date"}
            />
            {errors.date && <p className="text-red-500">{errors.date}</p>}
          </div>

          <div>
            <Input
              lableName={"Non VAT SALE"}
              inputType={"number"}
              onChange={handleChange}
              value={data?.nonvatsale}
              name={"nonvatsale"}
            />
            {errors.nonvatsale && (
              <p className="text-red-500">{errors.nonvatsale}</p>
            )}
          </div>

          <div>
            <Input
              lableName={"VAT Sale"}
              inputType={"number"}
              onChange={handleChange}
              value={data.vatsale}
              name={"vatsale"}
            />
            {errors.vatsale && <p className="text-red-500">{errors.vatsale}</p>}
          </div>

          <div>
            <Input
              lableName={"VAT Amount"}
              inputType={"number"}
              currency={true}
              onChange={handleChange}
              value={data.vatamount}
              name={"vatamount"}
            />
            {errors.vatamount && (
              <p className="text-red-500">{errors.vatamount}</p>
            )}
          </div>

          <div>
            <Input
              lableName={"Cash Amount"}
              inputType={"number"}
              currency={true}
              onChange={handleChange}
              value={data.cashamount}
              name={"cashamount"}
            />
            {errors.cashamount && (
              <p className="text-red-500">{errors.cashamount}</p>
            )}
          </div>

          <div>
            <Input
              lableName={"Bank Amount"}
              inputType={"number"}
              currency={true}
              onChange={handleChange}
              value={data.bankamount}
              name={"bankamount"}
            />
            {errors.bankamount && (
              <p className="text-red-500">{errors.bankamount}</p>
            )}
          </div>

          <div>
            <Input
              lableName={"Lottery"}
              inputType={"number"}
              currency={true}
              onChange={handleChange}
              value={data.lottery}
              name={"lottery"}
            />
            {errors.lottery && <p className="text-red-500">{errors.lottery}</p>}
          </div>

          <div>
            <Input
              lableName={"Payzone"}
              inputType={"number"}
              currency={true}
              onChange={handleChange}
              value={data.payzone}
              name={"payzone"}
            />
            {errors.payzone && <p className="text-red-500">{errors.payzone}</p>}
          </div>

          <div>
            <Input
              lableName={"Oyester"}
              inputType={"number"}
              currency={true}
              onChange={handleChange}
              value={data.oyester}
              name={"oyester"}
            />
            {errors.oyester && <p className="text-red-500">{errors.oyester}</p>}
          </div>
        </div>

        <div className="mt-12 max-sm:mt-8 flex justify-center items-center gap-x-7  max-sm:gap-x-4">
          <Button
            disabled={loading}
            type={"submit"}
            children={
              <div className="flex items-center">
                {loading && <Loader />}Save
              </div>
            }
            className={"bg-green hover:bg-darkgreen text-white"}
          />
          <Button
            disabled={loading}
            onClick={resetForm}
            children={"Cancel"}
            className={
              "border border-green hover:bg-gray-100 hover:border-darkgreen text-green hover:text-darkgreen"
            }
          />
        </div>
      </div>
    </form>
  );
};

export default TransactionSaleForm;
